module.exports = __webpack_public_path__ + "static/media/guide.f9bab360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/travel/guide.jpg
// module id = 745
// module chunks = 0